<template>
    <div class="header-wrap">
        <div class="left">
            <img
                @click="goBack"
                class="icon-back"
                src="../../../assets/back-black.png"
            />
            <div class="info">
                <p>{{ stockname | formatInfo }}</p>
                <p>
                    <img class="market-icon" v-if="market === 'SZ'" src="../../../assets/szicon.png" />
                    <img class="market-icon" v-else src="../../../assets/shicon.png" />
                    {{ code }}
                </p>
            </div>
        </div>
        <div class="title">
            <p>发新帖</p>
            <p>{{ userInfo.nickname | formatInfo }}</p>
        </div>
        <button
            :class="canSubmit ? 'submit' : 'submit disabled'"
            @click="canSubmit && handleSubmit && handleSubmit()"
        >
            发布
        </button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    props: {
        canSubmit: {
            type: Boolean,
            default: false
        },
        handleSubmit: {
            type: Function,
            default: () => { }
        }
    },
    computed: {
        ...mapState(['status', 'code', 'market', 'stockname', 'dyna', 'region', 'userInfo']),
    },
    filters: {
        formatInfo(data) {
            if (data.length > 8) {
                return data.substring(0, 8)
            }
            return data
        }
    },
    methods: {
        goBack() {
            this.$router.push({
                path: `/${this.market}/${this.code}.html`,
            })
        },
        marketTransform(val) {
            let keytmar = {
                NASDAQ: 'NASDAQ',
                nasdaq: 'NASDAQ',
                NA: 'NASDAQ',
                sh: 'sh',
                SH: 'sh',
                sz: 'sz',
                SZ: 'sz',
                HK: 'HKSE',
                hk: 'HKSE',
                hkse: 'HKSE',
                AMEX: 'AMEX',
                amex: 'AMEX',
                AM: 'AMEX',
                am: 'AMEX',
                HKIDX: 'HKIDX',
                hkidx: 'HKIDX'
            }
            return keytmar[val] || 'sh'
        },
    }

}
</script>

<style lang="stylus" scoped>
.header-wrap
    width 100%
    height 54px
    background #fff
    padding 0 10px
    display flex
    justify-content space-between
    align-items center
    border-bottom 1px solid #F5F5F5

    .left
        display flex
        justify-content space-between
        align-items center

        .icon-back
            width 10px
            height 20px
            margin-right 12px

        .info
            >p
                font-size 12px
                font-weight 400
                color #666666
                line-height 17px

            >p:first-child
                font-size 15px
                font-weight 500
                color #333333
                line-height 21px

        .market-icon
            width 15px
            height 10px
            margin-right 4px

    .title
        flex 1
        text-align center

        >p
            font-size 12px
            font-weight 400
            color #666666
            line-height 17px

        >p:first-child
            font-size 15px
            font-weight 500
            color #000000
            line-height 21px

    .submit
        font-size 14px
        font-weight 400
        color #FFFFFF
        line-height 20px
        padding 4px 15px
        background #E94041
        border-radius 2px
        border none
        outline none
        box-shadow none

        &.disabled
            opacity 0.29
</style>
